import * as React from 'react';
import { SelectSingleContext } from './SelectSingleContext';
/** Hook to access the [[SelectSingleContext]]. */
export function useSelectSingle() {
    var context = React.useContext(SelectSingleContext);
    if (!context) {
        throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    }
    return context;
}
//# sourceMappingURL=useSelectSingle.js.map